module.exports = __webpack_public_path__ + "img/elkerathmann.03d5cf9a.jpg";